import { ANALYTICS_ENABLED_BY_STANDORTGRUPPEN_ID } from '@/domain/navigation/features/navigation/hooks/useAnalyticsEnabled/graphql/queries';
import {
  AnalyticsEnabledByStandortGruppenIdQuery,
  AnalyticsEnabledByStandortGruppenIdQueryVariables,
} from '@/gql/graphql';
import { useSuspenseQuery } from '@apollo/client/react';
import * as Sentry from '@sentry/react';

export function useAnalyticsEnabled(standortGruppenId: string): {
  istAnalyticsAktiviert: boolean;
  error?: string;
} {
  const result = useSuspenseQuery<
    AnalyticsEnabledByStandortGruppenIdQuery,
    AnalyticsEnabledByStandortGruppenIdQueryVariables
  >(ANALYTICS_ENABLED_BY_STANDORTGRUPPEN_ID, {
    variables: { standortGruppenId },
  });

  if (result.error) {
    Sentry.captureException(result.error);
    return { istAnalyticsAktiviert: false };
  }

  return {
    istAnalyticsAktiviert:
      result.data.navigation_standortgruppeById.istAnalyticsEnabled,
  };
}
